import { createFileRoute } from '@tanstack/react-router';
import { ConsumoPage } from '@/components/ConsumoPage';

export const Route = createFileRoute('/_authenticated/consumo/')({
  component: ConsumoPage,
});
